import axios from 'axios';
import { z } from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export type Request = ShoppingCart;

export type ShoppingCart = {
	state: 'Live' | 'Approved' | 'Review';
	isDefault: boolean;
	nameTranslations: Translation;
	descriptionTranslations: Translation;
};

type Translation = {
	[key: string]: string;
};

export interface Response {
	data: ResponseData;
}

const TranslationsSchema = z.record(z.string());

const ShoppingCartSchema = z.object({
	id: z.string().uuid(),
	state: z.enum(['Live', 'Approved', 'Review']),
	isDefault: z.boolean(),
	lastEditedDateUtc: z.string().datetime(),
	creator: z.string().nullable(),
	creatorId: z.string().uuid(),
	nameTranslations: TranslationsSchema,
	descriptionTranslations: TranslationsSchema,
});

export type ResponseData = z.infer<typeof ShoppingCartSchema>;
const validator = createValidator(ShoppingCartSchema);

export async function callApi(request: Request): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/ShoppingCart`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
